import styled from "styled-components";
import { space, color, layout, flexbox } from "styled-system";

// Box is a low level CSS-in-JS solution, All CSS properties are set using simple React props, which allows you to easily create reusable components that can be enhanced with additional CSS properties.
export const Box = styled.div(
  {
    boxSizing: "border-box",
    minWidth: 0
  },
  color,
  flexbox,
  layout,
  space
);

export default Box;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/Box.js